module.exports = __webpack_public_path__ + "img/SDOF_Pic.4c0cd95a.png";